export const getParams = (params: UrlParams) => {
  for (let [k, v] of Object.entries(params)) {
    if (['file', 'people', 'matter'].includes(k) && v) {
      return [k, v]
    }
  }
}

export const getType = (title: string) => {
  const reg = {
    img: /(jpe?g|png|gif)$/g,
    doc: /(pdf|docx?|pptx?|xlsx?)$/g,
  }

  for (let arr of Object.entries(reg)) {
    const [type, reg] = arr
    if (reg.test(title)) {
      return type
    }
    return 'others'
  }
}

export const getSize = (byte: number) => {
  const n = 1024
  const kb = Math.round(byte / n)
  if (kb < n) return `${kb}KB`
  return `${Math.round(kb / n)}MB`
}

export const getFileIcon = (ext: string, noMask: Boolean) => {
  const reg: { [k: string]: RegExp } = {
    image: /(jpe?g|png|gif)$/g,
    word: /(docx?)$/g,
    excel: /(xlsx?)$/g,
    ppt: /(pptx?)$/g,
    pdf: /(pdf)$/g,
    zip: /(zip)$/g,
  }

  let type = Object.keys(reg).find((key) => {
    return reg[key].test(ext)
  })

  return `./images/icon-file${noMask ? '' : '/mask'}/${type || 'unknow'}.png`
}

export const getEntry = () => {
  const editorType = window.localStorage.getItem('editorType') as EditorType
  return editorType === 'diary' ? '笔记' : '协作信息'
}
